import { LDProvider } from 'launchdarkly-react-client-sdk';
import { StrictMode } from 'react';

import { ToasterProvider } from '@crossnokaye/ux-common';

import { AppConfigs } from '@/config';
import { QueryProvider } from '@/providers/query-provider';
import { ThemeProvider } from '@/theme/theme-provider';

interface AppProvidersProps {
  children?: React.ReactNode;
}

export const AppProviders = ({ children }: AppProvidersProps) => {
  return (
    <StrictMode>
      <ThemeProvider>
        <ToasterProvider>
          <LDProvider
            clientSideID={AppConfigs.launchDarklyClientSideId}
            deferInitialization={!AppConfigs.launchDarklyClientSideId}
          >
            <QueryProvider>{children}</QueryProvider>
          </LDProvider>
        </ToasterProvider>
      </ThemeProvider>
    </StrictMode>
  );
};
